import FormationLayout from "./FormationLayout";

export default function FormationIA() {
  return (
    <FormationLayout
      seoTitle="Formation IA & Prompt Engineering — Form Action Pro"
      seoDesc="Formation IA et prompt engineering pour professionnels : comprendre les modèles d'IA, rédiger des prompts efficaces, déployer des usages concrets dans un cadre RGPD et AI Act. Durée 1 à 3 jours, sur devis."
      path="/formations/ia-prompt-engineering"
      kicker="Formation"
      title="IA & Prompt Engineering"
      subtitle="Comprendre les modèles d’IA, maîtriser l’art du prompt et déployer des usages concrets dans votre activité — sans jargon, avec méthode."
      dureeBadge="1 à 3 jours"
      publicCible="Dirigeants, managers, salariés, indépendants"
      objectifs={[
        "Expliquer le fonctionnement, les capacités et les limites d’un modèle de langage.",
        "Rédiger des prompts structurés et efficaces pour des tâches professionnelles réelles.",
        "Identifier et mettre en œuvre des cas d’usage de l’IA dans votre activité.",
        "Appliquer les règles essentielles du RGPD et de l’AI Act à vos usages de l’IA.",
      ]}
      programme={[
        {
          titre: "Comprendre l’IA générative",
          texte:
            "Modèles de langage, capacités et limites, vocabulaire essentiel, panorama des outils. De quoi prendre de la hauteur avant de pratiquer.",
        },
        {
          titre: "L’art du prompt",
          texte:
            "Structure d’un prompt efficace : rôle, contexte, consignes, format de sortie. Itérations, vérification des réponses, pièges classiques et hallucinations.",
        },
        {
          titre: "Usages métier",
          texte:
            "Rédaction, synthèse, organisation, pédagogie, relation client. Ateliers pratiques sur vos cas réels, apportés par les participants.",
        },
        {
          titre: "Cadre et responsabilité",
          texte:
            "RGPD, AI Act, confidentialité des données, bonnes pratiques professionnelles. Utiliser l’IA sans mettre votre structure en risque.",
        },
      ]}
      duree="1 à 3 jours"
      prerequis="aucun prérequis technique ; venir avec un ordinateur ou une tablette."
    />
  );
}
